import {Box, Tooltip, Typography} from '@mui/material';
import React from 'react';
import {uniq} from 'lodash';
import {useReviewContext} from '../../contexts/ReviewContext';
import {useFeaturePermission} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {HandoverStepType} from '../../pages/HandoverSummaryPage/HandoverStepTypes';
import {
  stepToValidationKey,
  validationHeaderMap,
} from '../../pages/HandoverSummaryPage/handoverValidationHelpers';

export const StepValidationTooltip: React.FC<{
  step: HandoverStepType;
  children: React.ReactElement;
}> = ({step, children}) => {
  const {reviewValidation: review} = useReviewContext();
  const canSeeTooltip = useFeaturePermission([
    GlobalPermissionEnum.can_access_admin_features,
  ]);

  const validationKey = stepToValidationKey[step];
  const errors = validationKey
    ? (review?.validation?.[validationKey] as string[] | null | undefined) ?? []
    : [];
  const uniqueErrors = uniq(errors);

  if (!canSeeTooltip || !validationKey || uniqueErrors.length === 0) {
    return children;
  }

  return (
    <Tooltip
      arrow
      placement="bottom"
      title={
        <Box p={1}>
          <Typography variant="subtitle2" sx={{fontWeight: 'bold', mb: 0.5}}>
            {validationHeaderMap[validationKey]}
          </Typography>
          <ul style={{margin: 0, paddingLeft: '18px'}}>
            {uniqueErrors.map((message, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`${validationKey}-${index}`}>
                <Typography variant="body2">{message}</Typography>
              </li>
            ))}
          </ul>
        </Box>
      }
    >
      {children}
    </Tooltip>
  );
};
